export enum LockPolicy {
    ALL = "all",
    FINANCIAL = "financial",
}

export interface Lock {
    id: number;
    entityId: number;
    date: Date | null;
    policy: LockPolicy;
}
